<template>
  <div id="delete-resource-modal" class="uk-flex-top" uk-modal>
    <div class="uk-modal-dialog uk-modal-body uk-margin-auto uk-margin-auto-vertical">
      <span class="uk-modal-title">{{$t('modals.declinedResource.whyWasTheResourceDeclined')}}</span>
      <div class="container">
        <p class="body-heading">{{$t('modals.declinedResource.reasons')}}</p>
        <div class="checkbox-container" uk-grid>
        <div class="uk-width-1-2">
          <div class="checkbox-margin">
            <img class="checkbox add-pointer"
                 @click="onClick(unsupportedContent.id)"
                 :src="unsupportedContent.selected ? selectedCheckbox : unselectedCheckbox">
            <span class="checkbox-text uk-text-middle">{{$t('modals.declinedResource.unsupportedContent')}}</span>
          </div>
          <div>
            <img class="checkbox add-pointer"
                 @click="onClick(copyrightInfringement.id)"
                 :src="copyrightInfringement.selected ? selectedCheckbox : unselectedCheckbox">
            <span class="checkbox-text uk-text-middle">{{$t('modals.declinedResource.copyrightInfringement')}}</span>
          </div>
        </div>
          <div class="uk-width-1-2">
            <div class="checkbox-margin">
              <img class="checkbox add-pointer"
                   @click="onClick(personalContent.id)"
                   :src="personalContent.selected ? selectedCheckbox : unselectedCheckbox">
              <span class="checkbox-text uk-text-middle">{{$t('modals.declinedResource.personalContent')}}</span>
            </div>
            <div>
              <img class="checkbox add-pointer"
                   @click="onClick(other.id)"
                   :src="other.selected ? selectedCheckbox : unselectedCheckbox">
              <span class="checkbox-text uk-text-middle">{{$t('modals.declinedResource.other')}}</span>
            </div>
          </div>
        </div>
        <div class="info-container">
          <div style="overflow: hidden">
            <span class="body-heading" style="float: left">{{$t('modals.declinedResource.additionalInformation')}}</span>
            <span style="float: right">
              <span>{{ $t('general.limit')}}:</span>
              <span :class="{'char-remaining-green': declineMessageLength >= 0, 'char-remaining-red': declineMessageLength < 0}"> {{declineMessageLength}}</span>
            </span>
          </div>
          <textarea class="uk-textarea" rows="8" type="text" :placeholder="$t('modals.declinedResource.describeIssues')" v-model="declineMessage"></textarea>
        </div>
      </div>
      <p class="uk-text-right button-container">
        <button class=" modal-button add-pointer uk-modal-close uk-text-capitalize"
          :class="{'cp-primary-button': !declineEnabled, 'cp-white-button': declineEnabled}" @click="setDefaultSelection">{{$t('general.cancel')}}</button>
        <button class="modal-button uk-modal-close"
                :class="{'disabled-button': !declineEnabled, 'cp-primary-button add-pointer': declineEnabled}"
                @click="declineResource"
                :disabled="!declineEnabled">{{$t('modals.declinedResource.declineResource')}}</button>
      </p>
    </div>
  </div>
</template>

<script>
    import iconUtil from '../../../utils/icon-util'
    import * as misc from '../../../enums/misc'
    import {UNSUPPORTED_CONTENT, COPYRIGHT_INFRINGEMENT, PERSONAL_CONTENT, OTHER} from '../../../enums/resource-decline-reasons'
    const MESSAGE_LIMIT = 500
    export default {
      name: 'decline-resource-confirmation',
      data() {
        return {
          unsupportedContent: {selected: false, id: UNSUPPORTED_CONTENT},
          copyrightInfringement: {selected: false, id: COPYRIGHT_INFRINGEMENT},
          personalContent: {selected: false, id: PERSONAL_CONTENT},
          other: {selected: false, id: OTHER},
          selectedCheckbox: iconUtil.resolve(misc.LRG_CHECKED),
          unselectedCheckbox: iconUtil.resolve(misc.LRG_UNCHECKED),
          declineMessage: ''
        }
      },
      methods: {
        declineResource() {
          const declinedInfo = this.declinedInfo()
          this.setDefaultSelection()
          this.$emit('decline-resource', declinedInfo)
        },
        onClick(checkbox) {
          switch (checkbox) {
            case this.unsupportedContent.id:
              if (this.unsupportedContent.selected) {
                this.unsupportedContent.selected = false
              } else {
                this.unsupportedContent.selected = true
              }
              break
            case this.copyrightInfringement.id:
              if (this.copyrightInfringement.selected) {
                this.copyrightInfringement.selected = false
              } else {
                this.copyrightInfringement.selected = true
              }
              break
            case this.personalContent.id:
              if (this.personalContent.selected) {
                this.personalContent.selected = false
              } else {
                this.personalContent.selected = true
              }
              break
            case this.other.id:
              if (this.other.selected) {
                this.other.selected = false
              } else {
                this.other.selected = true
              }
              break
          }
        },
        declinedInfo() {
          let selectedReasons = []
          if (this.unsupportedContent.selected) {
            selectedReasons.push(this.unsupportedContent.id)
          }
          if (this.copyrightInfringement.selected) {
            selectedReasons.push(this.copyrightInfringement.id)
          }
          if (this.personalContent.selected) {
            selectedReasons.push(this.personalContent.id)
          }
          if (this.other.selected) {
            selectedReasons.push(this.other.id)
          }
          return {reasons: selectedReasons, message: this.declineMessage}
        },
        setDefaultSelection() {
          this.unsupportedContent.selected = false
          this.copyrightInfringement.selected = false
          this.personalContent.selected = false
          this.other.selected = false
          this.declineMessage = ''
        }
      },
      computed: {
        declineEnabled() {
          return this.declineMessageLength >= 0 && (this.unsupportedContent.selected || this.copyrightInfringement.selected || this.personalContent.selected || this.other.selected)
        },
        declineMessageLength() {
          return MESSAGE_LIMIT - this.declineMessage.length
        }
      }
    }
</script>

<style lang="scss" scoped>
  @import '../../../styles/colours';

  .body-heading {
    font-size: 18px;
    font-weight: bold;
    color: $content-text;
  }

  .button-container {
    margin-top: 56px;
  }

  .checkbox {
    height: 16px;
    width: 16px;
  }

  .checkbox-container {
    margin-top: 25px
  }

  .checkbox-margin {
    margin-bottom: 20px;
  }

  .checkbox-text {
    font-size: 18px;
  }

  .container {
    margin-top: 25px;
  }

  .char-remaining-green {
    font-size: 18px;
    color: green;
  }

  .char-remaining-red {
    font-size: 18px;
    color: red;
  }

  .disabled-button {
    background-color: $app-background;
    color: $light-grey;
    border-radius: 2px;
    border: solid 2px $light-grey;
  }

  .info-container {
    margin-top: 30px;
  }

  .modal-button {
    width: 240px;
    height: 44px;
    font-size: 18px;
    font-weight: bold;
  }

  .uk-modal-dialog {
    width: 676px;
    border-radius: 2.8px;
    box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.24);
    background-color: $lightest-gray;
  }

  .uk-modal-title {
    font-size: 24px;
    font-weight: bold;
    margin-top: 32px;
    color: $content-text;
  }

  .uk-textarea {
    resize: none;
  }

</style>
